module.exports = __webpack_public_path__ + "static/media/ContasPagRec4.850bf9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec4.png
// module id = 2013
// module chunks = 0